import React from 'react';

export const SeoMetadataFieldsContext = React.createContext({
  onChange: () => {},
});
export const SeoMetadataFieldsProvider = SeoMetadataFieldsContext.Provider;
